var DialogRecurrencesModule = /** @class */ (function () {
    function DialogRecurrencesModule() {
    }
    return DialogRecurrencesModule;
}());
export { DialogRecurrencesModule };
